import { useRef } from 'react';

let widgetIndex = 0;

export function useWidgetsIndex() {
  const indexRef = useRef<number | null>(null);
  if (indexRef.current === null) {
    indexRef.current = widgetIndex;
    widgetIndex += 1;
  }

  return indexRef.current;
}
